import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { HiDotsVertical } from 'react-icons/hi'
import { ColumnsTable } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { HeaderProps } from '../../components/Layout/Header'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { formatPipe, getDenomination } from '../../utils/utils'
import ServicesForm from './ServicesForm'
import { Box, Card, CardContent, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

const server = process.env.REACT_APP_SERVER_URL
const Services: React.FC<IServicesProps> = ({ setHeaderActions }) => {
  const [modal, setModal] = useState<boolean>(false)

  const { addAlert } = useSnackBars()

  const [selectedServiceEdit, setSelectedServiceEdit] = useState<any | null>(null)

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const [servicesInfo, setServicesInfo] = useState<{
    services: any[]
    loading: boolean
    numberOfPages: number
    currentPage: number
  }>({
    services: [],
    loading: false,
    numberOfPages: 0,
    currentPage: 0,
  })

  const [searchParams, setSearchParams] = useState<string[]>([])

  const [fastSearch, setFastSearch] = useState<string>('')

  const [menuVisible, setMenuVisible] = useState<any>()

  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)

  const [selectedServiceToDelete, setSelectedServiceToDelete] = useState<
    any | null
  >()

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Tipo de Iva',
      dataIndex: 'ivaType',
      key: 'ivaType',
      render: (id: number, record: any) => {
        let objTransform = {
          GENERAL: 'GENERAL',
          REDUCED: 'REDUCIDO',
          EXEMPT: 'EXENTO',
          SUMPTUARY: 'SUNTUARIO',
        }
        return (
          <ColumnItemWrapper>{objTransform[record.ivaType]}</ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record?.price
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => (
        <ColumnItemWrapper floatingMenu>
          {/* <div className="text-gray-500 relative"> */}
          <FloatingMenu
            visible={menuVisible === id}
            onClose={() => {
              setMenuVisible(-1)
            }}
            options={{
              onEdit: () => {
                setSelectedServiceEdit(record)
                setModal(true)
              },
              onDelete: () => {
                setSelectedServiceToDelete(record)
                setShowModalConfirm(true)
                // selectedServiceToDelete(record)
              },
            }}
          >
            <HiDotsVertical
              className="cursor-pointer dark:text-white text-primaryGray-400"
              onClick={() => {
                setMenuVisible(id)
                // setEdit(record)
                // setModal(true)
              }}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  const [userConfig] = useLocalStorageState('user-config')

  const { loading, numberOfPages, services } = servicesInfo

  useEffect(() => {
    if (userRole === 'seniat') {
      setHeaderActions({
        advancedSearch: async (value) => {
        if (typeof value === 'boolean') {
          //   setModalSearch(value)
          return
        }
        getServices([], 0, value)
      },
      cleanFilters: {
        sort: () => {},
        search: async () => {
          // setSearchParams([])
          getServices([], 0)
          // getAccountReceivables([], 0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
    })
    } else {
      setHeaderActions({
        addAction: () => setModal(true),
        advancedSearch: async (value) => {
        if (typeof value === 'boolean') {
          //   setModalSearch(value)
          return
        }
        getServices([], 0, value)
      },
      cleanFilters: {
        sort: () => {},
        search: async () => {
          // setSearchParams([])
          getServices([], 0)
          // getAccountReceivables([], 0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
    })
    }
    

    return () => {
      setHeaderActions(null)
    }
  }, [searchParams])

  useEffect(() => {
    getServices()
  }, [])

  const getServices = async (
    params: string[] = searchParams,
    pageNumber: number = 0,
    fastParam : string = fastSearch
  ) => {
    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]
    setSearchParams(params)

    setFastSearch(fastParam)

    try {
      setServicesInfo((prevState) => ({
        ...prevState,
        loading: true,
        currentPage: pageNumber + 1,
      }))
      let response = await axios.get(
        `${server}/service?${[...params, ...paginationParams, `name=${fastParam}`].join('&')}`
      )
      setServicesInfo((prevState) => ({
        ...prevState,
        services: response?.data?.services,
        numberOfPages: response?.data?.numberOfPages || 1,
        loading: false,
      }))
      //   setServicesInfo({
      //     services: response?.data?.services,
      //     numberOfPages: response?.data?.numberOfPages || 1,
      //     loading: false,
      //   })
    } catch (err) {
      console.log("error..", err)
      setServicesInfo((prevState) => ({
        ...prevState,
        loading: false
      }))
    }
  }

  let objTransform = {
    GENERAL: 'GENERAL',
    REDUCED: 'REDUCIDO',
    EXEMPT: 'EXENTO',
    SUMPTUARY: 'SUNTUARIO',
  }

  return (
    <div>

      <div className="hidden md:block">
      <Table
        columns={userRole === 'seniat' ? columns.slice(0, -1) : columns}
        data={services}
        loading={loading}
        pages={numberOfPages}
        setPageSelected={(page) => {
          console.log("pagee...", page)
          getServices([], page)
        }}
      />
      </div>

      <div className="block md:hidden">
      {services?.map((service : any) => (
          <Card className="mt-5">

            <Box sx={{padding: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <Typography gutterBottom variant="h4" >
                {service?.name}
              </Typography>

              <FloatingMenu
            visible={menuVisible === service?.id}
            onClose={() => {
              setMenuVisible(-1)
            }}
            options={{
              onEdit: () => {
                setSelectedServiceEdit(service)
                setModal(true)
              },
              onDelete: () => {
                setSelectedServiceToDelete(service)
                setShowModalConfirm(true)
                // selectedServiceToDelete(record)
              },
            }}
          >
            <HiDotsVertical
              className="cursor-pointer dark:text-white text-primaryGray-400"
              onClick={() => {
                setMenuVisible(service?.id)
                // setEdit(record)
                // setModal(true)
              }}
            />
          </FloatingMenu>

            </Box>


            <CardContent>
             
              <Typography gutterBottom variant="h6">
                <strong>Tipo de iva:</strong> {objTransform[service?.ivaType]}
              </Typography>

              <Typography gutterBottom variant="h6">
                <strong>Precio:</strong>  {`${getDenomination(service?.currency?.id)} ${formatPipe(
            service?.price
          )}`}
              </Typography>

              {/* <Typography
              gutterBottom
              variant="h6"
            >
              Marca: {item?.brand}
            </Typography> */}

              <Typography gutterBottom variant="h6">
                <strong>SKU:</strong> {service?.sku}
              </Typography>

            </CardContent>
          </Card>
        ))}

      </div>

   

      <Modal display={modal} onClose={() =>{
        setSelectedServiceEdit(null)
         setModal(false)
      }}
      xlClasses='lg:w-[700px] w-[500px]'
      >
        <ServicesForm
        useType={selectedServiceEdit ? 'edit' : 'create'}
          defaultValues={selectedServiceEdit}
          onCancel={() => {
            setSelectedServiceEdit(null)
            setModal(false)
          }}
          onSubmit={async (values) => {
            try {
              addAlert({
                message: 'Creando servicio',
                status: 'loading',
              })
              if (selectedServiceEdit) {
                await axios.patch(`${server}/service`, {...selectedServiceEdit, ...values})
                setSelectedServiceEdit(null)
              } else {
                await axios.post(`${server}/service`, values)
              }
              await getServices([], 0)
              addAlert({
                message: 'Servicio creado satisfactoriamente',
                status: 'success',
              })
              setModal(false)
            } catch (err) {
              addAlert({
                message: 'Error al crear servicio',
                status: 'error',
              })
            }
          }}
        />
      </Modal>

      <ModalConfirm
        title="¿Deseas eliminar este servicio?"
        displayConfirmModal={showModalConfirm}
        onCancel={() => {
          setShowModalConfirm(false)
          setSelectedServiceToDelete(null)
        }}
        onConfirm={async () => {
          try {
            addAlert({
              message: 'Cargando',
              status: 'loading',
            })
            await axios.delete(`${server}/service?id=${selectedServiceToDelete?.id}`)
            await getServices([], 0)
            setShowModalConfirm(false)
            setSelectedServiceToDelete(null)
            addAlert({
              message: 'Servicio eliminado satisfactoriamente',
              status: 'success',
            })
          } catch (err) {
            addAlert({
              message: 'Error al crear servicio',
              status: 'error',
            })
          }
        }}
      />
    </div>
  )
}

interface IServicesProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}

export default Services
